import AppTheme from '../theme/AppTheme';
import {
    Box,
    Modal
} from '@mui/material';

const TestingPage = (props: { disableCustomTheme?: boolean }) => {
    return (
        <AppTheme {...props}>
            <Modal open={true} disableAutoFocus disableRestoreFocus>
                <Box
                    position="absolute" top="30%" left="50%"
                    display="flex" flexDirection="column" justifyContent="space-between" alignItems="center"
                    sx={{
                        outline: 'none',
                        transform: 'translate(-50%, -30%)',
                        bgcolor: 'background.paper',
                        p: 4,
                        borderRadius: 2,
                        boxShadow: 24,
                        minWidth: 300,
                        minHeight: 180
                    }}
                >
                        {/* <Box>
                    <Typography variant="h3" fontWeight={'bold'} textAlign={'center'} gutterBottom>
                        unknown
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary" textAlign={'center'} gutterBottom>
                        unknown
                    </Typography>
                    <Typography variant="body1" textAlign={'center'} gutterBottom>
                        +1231312414
                    </Typography>
                    </Box>
                    <Box width="100%" display="flex" gap={2} justifyContent="center" mt={2}>
                        <Button fullWidth variant="contained" color="primary" onClick={() => console.log('')}>
                            Answer
                        </Button>
                        <Button fullWidth variant="contained" color="error" onClick={() => console.log('')}>
                            Reject
                        </Button>
                    </Box> */}
                    {/* <Typography variant="h3" fontWeight={'bold'} textAlign={'center'} gutterBottom>
                                  unknown
                                </Typography>
                                <Typography variant="subtitle1" color="text.secondary" textAlign={'center'} gutterBottom>
                                  unknown
                                </Typography>
                                <Typography variant="body1" textAlign={'center'} gutterBottom>
                                  Connected: +112312321
                                </Typography>
                                <Typography textAlign={'center'} variant="body2" sx={{ mb: 4 }}>
                                  Duration: 00:00
                                </Typography>
                                <Button
                                  variant="contained"
                                  color="error"
                                  fullWidth
                                  onClick={() => console.log('')}
                                >
                                  Hang Up
                                </Button> */}
                </ Box>
            </Modal>
        </AppTheme>
    );
};

export default TestingPage;
